import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APICoreService } from 'src/app/common/services/api-core/api-core.service';
import {
  CreateFiltersetRequest,
  ReportFiltersetDTO,
  UpdateFiltersetRequest,
} from '../../dtos/report-filterset.dto';

@Injectable({
  providedIn: 'root',
})
export class ReportFiltersetService {
  constructor(private apiService: APICoreService) {}

  getFiltersets(
    reportSlug: string
  ): Observable<{ items: ReportFiltersetDTO[] }> {
    return this.apiService.getRequest('reports-filtersets', {
      report_slug: reportSlug,
    });
  }

  getFilterset(id: number): Observable<ReportFiltersetDTO> {
    return this.apiService.getRequest(`reports-filtersets/${id}`);
  }

  createFilterset(
    body: CreateFiltersetRequest
  ): Observable<ReportFiltersetDTO> {
    return this.apiService.postRequest('reports-filtersets', body);
  }

  updateFilterset(
    id: number,
    body: UpdateFiltersetRequest
  ): Observable<ReportFiltersetDTO> {
    return this.apiService.putRequest(`reports-filtersets/${id}`, body);
  }

  deleteFilterset(id: number): Observable<void> {
    return this.apiService.deleteRequest(`reports-filtersets/${id}`);
  }

  applyFilterset(
    id: number
  ): Observable<{ id: number; last_applied_at: number }> {
    return this.apiService.postRequest(`reports-filtersets/${id}/apply`, {});
  }
}
